import { deepMerge } from '@utils/object/deepMerge';

import { type WhitVersion } from '../types';

const mergeByVersion = <TData extends WhitVersion>(
  initialData: TData,
  newData: TData,
) => {
  if (initialData.version === newData.version) {
    return deepMerge(initialData, newData);
  }

  return initialData;
};

export { mergeByVersion };
